import { render, staticRenderFns } from "./AccountLanguagesTable.vue?vue&type=template&id=83d73152&scoped=true"
import script from "./AccountLanguagesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountLanguagesTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AccountLanguagesTable.vue?vue&type=style&index=0&id=83d73152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d73152",
  null
  
)

export default component.exports